<template>
 <v-card class="my-5" outlined>
    <AdCardTitle inline>{{ $t('identifier-associations') }}</AdCardTitle>
    <v-card-text class="pa-0">
      <v-data-table
        class="elevation-2"
        :headers="headers"
        :items="associations"
        item-key="ref"
        :no-data-text="$t('no-items')"
        dense
        disable-pagination
        disable-sort
        disable-filtering
        hide-default-footer
      />
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    associations: {
      type: Array,
      default: () => ([])
    }
  },
  computed: {
    headers () {
      return [
        { value: 'ref', text: this.$t('id') },
        { value: 'refdisplay', text: this.$t('display-name') }
      ]
    }
  }
}
</script>
